import { Label } from "@radix-ui/react-dropdown-menu";

import { label } from "../../css/menu";
import { styled } from "../../theme/stitches";

export const DropdownLabel = styled(Label, label);
